<template>
    <div class="winnow-item-view">
        <h3>{{item.name}}</h3>
        <h4>{{item.desc}}</h4>
        <img :src="item.img">
    </div>
</template>

<script>
    export default {
        name: "winnowItemView",
        props: ["item"]
    };
</script>

<style lang="scss">
    .winnow-item-view {
        width: 100px;
        height: 100px;
        background-color: #f6f6f6;
        margin: 5px 10px 10px 0;
        text-align: center;
        float: left;
        h3 {
            font-size: 13px;
            margin: 7px 0 11px;
            font-weight: 800;
        }
        h4 {
            font-size: 12px;
            margin-bottom: 11px;
            font-weight: 800;
        }
        img {
            width: 60%;
        }
    }
</style>